export default "__VITE_ASSET__uw$$FPKc__"